export const ORDR_FORMS: any[] = [
    {
            "fieldSets" : [ {
              "fieldSetName" : "Default",
              "fields" : [ "statusId", "orderTypeId", "storeName", "orderName", "orderDate", "currencyUom", "internalCode", "salesChannel", "originFacilityId", "createdBy", "agreementId" ]
            } ],
            "formName" : "OrderInfo",
            "altTarget" : [ ],
            "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
            "type" : "single",
            "fields" : [ {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "orderId",
              "description" : "WSCO10731",
              "style" : "",
              "id" : "OrderInfo_orderId",
              "title" : "Order ID",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "statusId",
              "description" : "",
              "style" : "",
              "id" : "OrderInfo_statusId",
              "title" : "Status",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "orderTypeId",
              "description" : "Sales Order",
              "style" : "",
              "id" : "OrderInfo_orderTypeId",
              "title" : "Order Type",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "storeName",
              "description" : "Kwikstore",
              "style" : "",
              "id" : "OrderInfo_storeName",
              "title" : "Store Name",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "orderName",
              "description" : "",
              "style" : "",
              "id" : "OrderInfo_orderName",
              "title" : "Order Name",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "orderDate",
              "description" : "2024-06-11 02:16:09.174",
              "style" : "",
              "id" : "OrderInfo_orderDate",
              "title" : "Date Ordered",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "currencyUom",
              "description" : "",
              "style" : "",
              "id" : "OrderInfo_currencyUom",
              "title" : "Currency",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "internalCode",
              "description" : "",
              "style" : "",
              "id" : "OrderInfo_internalCode",
              "title" : "Internal Code",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "salesChannel",
              "description" : "Web Channel",
              "style" : "",
              "id" : "OrderInfo_salesChannel",
              "title" : "Sales Channel",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "originFacilityId",
              "description" : "WebStoreWarehouse",
              "style" : "",
              "id" : "OrderInfo_originFacilityId",
              "title" : "Origin Facility",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "createdBy",
              "description" : "system",
              "style" : "",
              "id" : "OrderInfo_createdBy",
              "title" : "Created By",
              "type" : "DISPLAY",
              "imageLocation" : ""
            }, {
              "fieldHelpText" : "",
              "ajaxEnabled" : false,
              "size" : 0,
              "name" : "agreementId",
              "description" : "",
              "style" : "",
              "id" : "OrderInfo_agreementId",
              "title" : "Agreement",
              "type" : "DISPLAY",
              "imageLocation" : ""
            } ],
            "target" : ""

      },

]
